import { useTheme } from '@mui/material/styles';
import { Grid2 as Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import SelectClinic from './SelectClinic';

function SelectClinicPage() {
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid size={12}>
                <Grid
                    container
                    direction={matchDownSM ? 'column-reverse' : 'row'}
                    alignItems="center"
                    justifyContent="center"
                >
                    <Grid>
                        <Stack alignItems="center" justifyContent="center" spacing={1}>
                            <Typography
                                color={theme.palette.secondary.main}
                                gutterBottom
                                variant={matchDownSM ? 'h3' : 'h2'}
                            >
                                Escolha a Sua Unidade de Saúde
                            </Typography>
                            <Typography
                                variant="caption"
                                fontSize="16px"
                                textAlign={matchDownSM ? 'center' : 'inherit'}
                            >
                                Por favor, selecione sua unidade de saúde antes de continuar.
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>
            </Grid>
            <Grid size={12}>
                <SelectClinic />
            </Grid>
        </Grid>
    );
}

export default SelectClinicPage;
